/* eslint-disable react/destructuring-assignment */
import React, { useContext, useState } from "react";
import { string, arrayOf, bool, func } from "prop-types";
import GridTable from "pages/_components/GridTable/GridTable";
import ProductList from "pages/_components/product/SimpleList";
import CustomData from "pages/_components/CustomData/CustomData";
import { TransactionContext } from "pages/_components/TransactionCard/TransactionContext";
import FormattedAmount from "pages/_components/FormattedAmount";
import FormattedDate from "pages/_components/FormattedDate";
import Button from "pages/_components/Button";
import I18n from "pages/_components/I18n";
import { TransactionSign } from "pages/_components/TransactionCard";
import TitleColumns from "./TitleColumns";
import ItemRow from "./ItemRow";
import Table from "./SumaryTable";

const CreditBillsSummaryBody = (props) => {
    const { isDesktop, isRecipt, showMoreData, setShowMoreData } = props;
    const { transaction = {} } = useContext(TransactionContext);
    const { data = {} } = transaction;
    const { cbu = props.cbu, invoiceList = props.invoiceList } = data;
    const row = isDesktop ? 1 : 4;

    const [buttonLabel, setButtonLabel] = useState("echecks.seeMore.button");
    const handleSeeMoreData = () => {
        setShowMoreData(!showMoreData);
        if (!showMoreData) {
            setButtonLabel("echecks.seeLess.button");
        } else {
            setButtonLabel("echecks.seeMore.button");
        }
    };

    const formatedData = invoiceList?.map((item) => ({
        buyer: (
            <div>
                {item?.facturaId?.cuitEmisor} <br /> {item?.razonSocialEmisor}
            </div>
        ),
        emitter: (
            <div>
                {item?.cuitComprador} <br /> {item?.razonSocialComprador}
            </div>
        ),
        emisionDate: <FormattedDate date={item?.fechaEmision} dateFormat="DD/MM/YYYY" />,
        expireryDate: <FormattedDate date={item?.fechaVencimientoPago} dateFormat="DD/MM/YYYY" />,
        amount: <FormattedAmount currency={item?.moneda} quantity={item?.saldoAceptado} />,
    }));
    return (
        <div className="credit-bills">
            {!isRecipt && (
                <>
                    <div className="box box-border-soft soft-inform-control">
                        <GridTable>
                            <GridTable.Container columns={1} rows={1}>
                                <GridTable.Data columnStart={1} rowStart={1} columnWidth={1}>
                                    <CustomData
                                        titleText="credit.bills.new.cbu"
                                        titleTextType="I18N"
                                        valueText={cbu}
                                        valueTextType="TEXT"
                                    />
                                </GridTable.Data>
                            </GridTable.Container>
                        </GridTable>
                    </div>
                    <ProductList
                        fetchingWithPreviousData
                        items={invoiceList || []}
                        renderItem={(item) => (
                            <GridTable.Container className={!isDesktop && "box box-shadow"}>
                                <ItemRow key={`bill-${item.id}`} data={item} isDesktop={isDesktop} />
                            </GridTable.Container>
                        )}>
                        {(listItem) => (
                            <GridTable className="tablelist-inform-summary">
                                {isDesktop && (
                                    <GridTable.Header>
                                        <GridTable.Container rows={row}>
                                            <TitleColumns />
                                        </GridTable.Container>
                                    </GridTable.Header>
                                )}
                                <GridTable.Body>{listItem}</GridTable.Body>
                            </GridTable>
                        )}
                    </ProductList>
                </>
            )}
            {isRecipt && (
                <div className="ticket__body">
                    <div className="ticket-header-info">
                        <CustomData
                            titleText="credit.bills.new.cbu"
                            titleTextType="I18N"
                            valueText={cbu}
                            valueTextType="TEXT"
                        />
                    </div>
                    <div className="view-more-data-button" id="element-to-ignore">
                        <div className="ticket__divider inside-ticket__body">
                            <div className="ticket__notch ticket__notch--left"> </div>
                            <div className="ticket__notch ticket__notch--right"> </div>
                        </div>
                        <Button
                            aria-expanded={showMoreData ? "true" : "false"}
                            className="more-button"
                            label={buttonLabel}
                            bsStyle="link"
                            onClick={handleSeeMoreData}
                            image={showMoreData ? "figma/icon/arrow-up.svg" : "figma/icon/arrow-down.svg"}
                        />
                    </div>
                    <div className={`view-more-data ${showMoreData ? "expand " : "collapse"}`}>
                        <I18n id="credit.bills.fce.lote" component="h2" />
                        <Table data={formatedData} />
                        <TransactionSign noDate isDesktop={isDesktop} showMoreData={showMoreData} />
                    </div>
                </div>
            )}
        </div>
    );
};

CreditBillsSummaryBody.propTypes = {
    cbu: string,
    invoiceList: arrayOf({}),
    isRecipt: bool,
    isDesktop: bool,
    showMoreData: bool,
    setShowMoreData: func,
};

CreditBillsSummaryBody.defaultProps = {
    cbu: "",
    invoiceList: [],
    isRecipt: false,
    isDesktop: false,
    showMoreData: false,
    setShowMoreData: () => {},
};

export default CreditBillsSummaryBody;
